import React from 'react'

import Description from '../../../../components/Description/Description'

import Block from './components/Block/Block'

import styles from './InterestsSelector.module.scss'

const InterestsSelector = ({
    tags,
    selectedTags,
    onUpdateSelectedTags,
    descriptionTitle,
    descriptionSubTitle,
    isBusiness = false,
}) => {
    const onHandleTagClick = clickedTag => {
        if (selectedTags.some(tag => tag.name === clickedTag.name)) {
            onUpdateSelectedTags(selectedTags.filter(tag => tag.name !== clickedTag.name))
        } else {
            onUpdateSelectedTags([...selectedTags, clickedTag])
        }
    }

    return (
        <div className={styles.interestsSelector}>
            <Description className={styles.description} title={descriptionTitle} subTitle={descriptionSubTitle} />

            <ul className={styles.list}>
                {tags.map(item => (
                    <Block
                        key={item.parentTag.id}
                        item={item}
                        onTagClick={onHandleTagClick}
                        selectedTags={selectedTags}
                        isBusiness={isBusiness}
                    />
                ))}
            </ul>
        </div>
    )
}

export default InterestsSelector
